import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { client, urlFor } from '../sanityClient';
import { PortableText } from '@portabletext/react';
import { Typography, Button } from 'antd';

const { Title, Paragraph } = Typography;

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [latestPosts, setLatestPosts] = useState([]);

  useEffect(() => {
    client
      .fetch(`*[_type == "post" && slug.current == $slug][0]`, { slug })
      .then(setPost)
      .catch(console.error);
  }, [slug]);

  useEffect(() => {
    client
      .fetch(`*[_type == "post" && defined(slug.current)] | order(publishedAt desc)[0...3]{
        title,
        slug,
        publishedAt,
        summary,
        mainImage {
          asset->{ url }
        }
      }`)
      .then(setLatestPosts)
      .catch(console.error);
  }, []);

  if (!post) return <p>Laster...</p>;

const portableTextComponents = {
  types: {
    image: ({ value }) =>
      value?.asset?._ref ? (
        <img
          src={urlFor(value).width(800).url()}
          alt={value.alt || 'Blogg bilde'}
          style={{
            width: '100%',
            maxHeight: '500px',
            objectFit: 'cover',
            margin: '2rem 0',
            borderRadius: '8px',
          }}
        />
      ) : null,
  },
};

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 16px', minHeight: '100vh' }}>
      {/* Tilbakeknapp */}
      <Button
        type="text"
        onClick={() => navigate('/blog')}
        style={{
          color: '#f26549',
          padding: "0",
          fontSize: '1.1rem',
          fontWeight: '600',
          background: 'none',
          border: 'none',
          boxShadow: 'none',
          textAlign: 'left',
        }}
        onMouseOver={(e) => (e.currentTarget.style.background = 'none')}
        onMouseOut={(e) => (e.currentTarget.style.background = 'none')}
      >
        ← Tilbake til blogg
      </Button>

      {/* Tittel og metadata */}
      <Title>{post.title}</Title>
      <Paragraph type="secondary">
        {new Date(post.publishedAt).toLocaleDateString('nb-NO', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </Paragraph>

      {/* Hovedbilde */}
      {post.mainImage?.asset?.url && (
        <img
          src={post.mainImage.asset.url}
          alt={post.title}
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '24px' }}
        />
      )}

      {/* Brødtekst med støtte for bilde */}
      <PortableText value={post.body} components={portableTextComponents} />

      {/* Nyeste innlegg */}
      <div style={{ marginTop: '64px' }}>
        <Title level={2} style={{ marginBottom: '24px' }}>Nyeste innlegg</Title>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '32px',
          justifyContent: 'flex-start',
        }}>
          {latestPosts
  .filter((p) => !slug || p.slug.current !== slug)
  .slice(0, 2)
  .map((p) => (
              <Link
                key={p.slug.current}
                to={`/blog/${p.slug.current}`}
                style={{
                  display: 'block',
                  width: '100%',
                  maxWidth: '350px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                  backgroundColor: '#fff',
                  color: 'inherit',
                  textDecoration: 'none',
                  transition: 'box-shadow 0.2s ease-in-out',
                }}
                onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)')}
                onMouseOut={(e) => (e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)')}
              >
                <div style={{ height: '180px', overflow: 'hidden', backgroundColor: '#f5f5f5' }}>
                  <img
                    src={p.mainImage?.asset?.url || ''}
                    alt={p.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: p.mainImage?.asset?.url ? 'cover' : 'none',
                      backgroundColor: '#fff',
                    }}
                  />
                </div>
                <div style={{ padding: '16px' }}>
                  <h3 style={{ fontSize: '1.1rem', marginBottom: '4px' }}>{p.title}</h3>
                  <p style={{ fontSize: '0.8rem', color: '#777', marginBottom: '8px' }}>
                    {new Date(p.publishedAt).toLocaleDateString('nb-NO')}
                  </p>
                  <p style={{ fontSize: '0.95rem', color: '#444' }}>{p.summary}</p>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
